import isEqual from 'lodash/isEqual';
import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {requestContext} from '../../../../../../common/requestContext';
import {usePrevious} from '../../../../../../common/shared/hooks/usePrevious';
import {events} from '../constant/textViewerSagaEvents';
import {clearTextViewerStatus} from '../state/textViewerSlice';
import {FrameSize} from '../type/FrameSize.interface';
import {useCountTriggerTextViewerCoreOption} from './useCountTriggerTextViewerCoreOption.hook';

export function useCheckTextViewerNeedsLoadContent({
  productId,
  size,
}: {
  productId: number;
  size: FrameSize;
}) {
  const dispatch = useDispatch();

  const option = useCountTriggerTextViewerCoreOption({
    size,
    isMobile: requestContext.requestInfo.display.isMobile,
  });
  const prevOption = usePrevious(option);

  useEffect(() => {
    return () => {
      dispatch(clearTextViewerStatus({productId}));
    };
  }, [dispatch, productId]);

  useEffect(() => {
    if (
      !size.width ||
      !size.height ||
      !prevOption ||
      isEqual(option, prevOption)
    ) {
      return;
    }

    dispatch(events.textViewerContentLoadRequired({productId}));
  }, [dispatch, option, prevOption, productId, size]);
}
